import { computed, Injectable, signal } from '@angular/core';
import dayjs, { Dayjs } from 'dayjs';
import { RealEstate } from '@eadsysteme/ewsrealestateclient-v3';

export interface DateRange {
	validFrom: Dayjs;
	validTo: Dayjs;
	realEstate: RealEstate;
}

@Injectable({
	providedIn: 'root',
})
export class TenantUnitDateRangeFilterService {
	private readonly _validFrom = signal<Dayjs>(dayjs().subtract(1, 'year'));
	private readonly _validTo = signal<Dayjs>(dayjs());
	private readonly _realEstate = signal<RealEstate>(null);

	readonly validFrom$ = this._validFrom.asReadonly();
	readonly validTo$ = this._validTo.asReadonly();

	readonly dateRange = computed<DateRange>(() => ({
		validFrom: this._validFrom(),
		validTo: this._validTo(),
		realEstate: this._realEstate(),
	}));

	get validFrom(): Dayjs {
		return this._validFrom();
	}

	set validFrom(value: Dayjs) {
		this._validFrom.set(value);
	}

	get validTo(): Dayjs {
		return this._validTo();
	}

	set validTo(value: Dayjs) {
		this._validTo.set(value);
	}

	get realEstate(): RealEstate {
		return this._realEstate();
	}

	set realEstate(value: RealEstate) {
		this._realEstate.set(value);
	}

	/** Update both dates at once */
	setDateRange(validFrom: Dayjs, validTo: Dayjs): void {
		this._validFrom.set(validFrom);
		this._validTo.set(validTo);
	}

	/** Reset to default values */
	reset(): void {
		this._validFrom.set(dayjs().subtract(1, 'year'));
		this._validTo.set(dayjs());
	}
}
